import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;
export class userSectionPwa_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
        <!-- ko if: user() -->

        <ul data-bind="foreach: brands, attr: {'class': (brands().length > 10) ? 'brand-list is-smaller' : 'brand-list'}"
          class="brand-list ">
        
          <li
            data-bind="attr: {'class': (id == $parent.selectedBrandId()) ? 'is-selected brand-item': 'brand-item'}, css: iconImage">
            <a data-bind="attr: { href :  '/mobile/brand/' + id + '/analytics/live-dashboard/', title: name}"></a>
          </li>
        
        </ul>
        <div class="w-sidebar-user icon">
                    
                    
          <div class=" w-user-info">
            <a data-bind="attr: { href: '/mobile/analytics/live-dashboard' }"> 
              <button class="btn no-bg-pwa icon i-dashboard">Network Live Dashboard</button>
            </a>
        
          <button data-bind="event: { click: onClickLogOutAction}" class="btn no-bg-pwa icon i-logout">Log Out</button>
          </div>
        </div>
        <!-- /ko -->
                `;
    }

    protected onClickLogOutAction() {
            this.caller.logOut();
    }

    protected getTemplateName(): string{
        return "userSectionPwa-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string>{
        return ["user-section"];
    }

    protected buildViewModel(): any{
        let self = this;
        return {
            user: ko.observable(null),
            profilePicture: ko.observable("/assets/images/default-user.png"),
            isUserLinkDisabled: ko.observable(false),
            selectedBrandId: ko.observable(0),
            brands: ko.observableArray([]),
            origin: document.location.origin,
            onclickViewProfile: (data) => {
                self.onClickViewProfile(data.user().user.id);
            },
            onClickBrandIcon: (data) => {
                self.onClickBrandIcon(data);
            },
            onClickLogOutAction: function (data, event) {
                self.onClickLogOutAction();
            }
        };
    }

    public setUser(user: any){

        if(user.user.valnet_user.pictureUrl){
            this.getTemplateViewModel().profilePicture(user.user.valnet_user.pictureUrl);
        }

        this.getTemplateViewModel().selectedBrandId(this.caller.getGlobalBrandId());
        this.getTemplateViewModel().user(user);
    }

    public setBrands(brands) {

        this.getTemplateViewModel().brands(brands);
    }

    public onClickViewProfile(idUser){

        let isUserLinkDisabled = this.getTemplateViewModel().isUserLinkDisabled();

        if(!isUserLinkDisabled){
            this.caller.viewProfile(idUser);
        }
    }
    public onClickBrandIcon(data){

        this.getTemplateViewModel().selectedBrandId(data.id);

        this.caller.resetActiveMenus();
        this.caller.changeSelection(data.id);
    }
    public setIsUserLinkDisabled(isUserLinkDisabled: boolean){

        this.getTemplateViewModel().isUserLinkDisabled(isUserLinkDisabled);
    }

    public setSelectedBrandId(brandId: number): void {

        this.getTemplateViewModel().selectedBrandId(brandId);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/userSectionPwa_template.ts